<div class="page-container gap-24">
  <div class="page-title justify-space-between">
    <span class="font-bold-display-medium"> Buchungen </span>
    <div class="flex-r gap-16 align-center">
      <div style="min-width: 150px">
        <p-select
          [(ngModel)]="selectedYear"
          [options]="yearOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Jahr auswählen..."
          class="align-self-stretch" />
      </div>
      <button
        class="inwi-text-button-medium-primary"
        (click)="exportBookingsExcel()"
        pTooltip="Alle Buchungen als CSV exportieren (pro Buchung eine Zeile)"
        tooltipPosition="left">
        <div class="button-content">
          <i class="fa-regular fa-file-csv button-icon"></i>
          <div class="button-text">Als CSV exportieren</div>
        </div>
      </button>
      <button
        class="inwi-text-button-medium-secondary"
        (click)="exportBookingsExcelPerAttendee()"
        pTooltip="Alle Buchungen als CSV exportieren (pro Teilnehmer eine Zeile, gruppiert nach Buchung)"
        tooltipPosition="left">
        <div class="button-content">
          <i class="fa-regular fa-file-csv button-icon"></i>
          <div class="button-text">Pro Teilnehmer exportieren</div>
        </div>
      </button>
    </div>
  </div>

  <app-custom-table
    class="padding-bottom-24"
    [pageSize]="50"
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    titleMultipleResults="Buchungen"
    titleSingleResult="Buchung"
    [dataSource$]="dataSource$"
    [columns]="columns"
    [isLoading]="isLoading"
    [filters]="filters"
    noDataIcon="fa-book-open-cover"
    noDataMessage="Es gibt derzeit keine Buchungen."
    noSearchResultsIcon="fa-book-open-cover"
    noSearchResultsMessage="Es gibt keine Buchungen, die mit deinen Suchkriterien übereinstimmen." />
</div>
